import useOnlineStatus from "../hooks/useOnlineStatus";
import OfflineState from "./States/OfflineState";

const OfflineGate = ({ children }) => {
  const isOnline = useOnlineStatus();
  if (!isOnline) {
    return (
      <div className="min-h-screen bg-surface-low flex items-center justify-center">
        <OfflineState />
      </div>
    );
  }
  return children;
};

export default OfflineGate;
